export default {
  header: {
    title: "Participation and Staking Pools",
    description:
      "Cryptocurrency staking is an exceptional opportunity in the digital currency world that allows you to contribute to the security and stability of blockchain networks by locking your assets while also earning continuous rewards. This method is a simple and low-risk way to generate passive income without the need for complex trading experience or active management.",
    link_1: "Multi-Staking",
    link_2: "Frequently Asked Questions",
    link_3: "Staking Process Schedule",
    quick_access: "Quick Access",
    crypto_pool_investment_fund: "Crypto Pool Participation Fund",
    pool_investment_staking: "Participation Pools & Staking",
    uranus: "Uranus Fund",
    dialog_des:
      "Reward calculation starts at 3 PM on the plan's start date and becomes visible in the user panel one day later. Rewards are not calculated during the staking and unfreezing periods. The final reward will be deposited into the user’s wallet up to one day after the plan ends. If canceled early, cancellation requests submitted before 3 PM will be processed on the same day, and others will enter the unfreezing process from 3 PM the next day.",
    dialog_action: "Understood"
  },
  stakingPlans: {
    tab_1: "Participation Plans",
    tab_2: "My Plans",
    No_Plans_Found: "No plans were found.",
    No_Plans_For_This_Condition:
      "There are currently no plans for this condition.",
    View_More: "View more",
    filters: {
      ALL: "Show All",
      VIP: "Special Plan",
      MAX_PROFIT: "Maximum Profit",
      MIN_PROFIT: "Minimum Profit",
      MAX_TIME: "Maximum Time",
      MIN_TIME: "Minimum Time",
      FIXED: "Fixed",
      FLEXIBLE: "Flexible",
      COMPARE_ASSET: "Compare Asset",
      ACTIVE: "Active",
      TERMINATED: "Completed",
      CANCELED: "Cancelled",
      searchPlaceHolder: "Search Cryptocurrency"
    },
    plans: {
      flexibleConditions: "Flexible Conditions",
      details: {
        planDuration: "Staking Plan",
        apr: "Estimated APR",
        unlockDelay: "Unlock Delay",
        minMaxLimit: "Min/Max Limit",
        minMaxAPR: "Min/Max APR",
        availableToStake: "Remaining Plan",
        endDate: "Plan End Date",
        autoRenew: "Auto-Renew",
        joinedStaking: "Participate in Plan",
        openNotificationSent: "Open Notification Sent",
        expireTime: "Membership expiration date",
        expirePlan: "Completion of the plan",
        existed: "Exists",
        notExisted: "Does Not Exist",
        currentReward: "Current Reward",
        endSubscriptionTime: "End Subscription Time",
        finishedPlan: "The Plan Is Terminate.",
        View_Details: "View Details",
        planDateRange: "Plan Date Range",
        vipPlan: "VIP Plan"
      }
    },
    dialogDetail: {
      View_Complete_Plan_Information:
        "In this section, you can view all the general information related to your plan.",
      Plan_Information: "Plan Information",
      Plan_Timeline: "Plan Timeline",
      Reward_Table: "Reward Table",
      Invite_Friends: "Invite Friends",
      contributionHistory: "Contribution History",
      planInfo: {
        Estimated_Active_Reward_APR:
          "Estimated active reward, APR (Annual Percentage Rate)",
        Reward_Earned_To_Date: "Reward earned to date",
        Reward_Earned: "Reward earned",
        Your_Contribution: "Your contribution",
        Remaining_Days_Total_Days: "Remaining days / total days of the plan",
        Withdrawal_Fee: "Withdrawal fee",
        Auto_Renewal_Fee: "Auto renewal fee",
        Waiting_Period_For_Asset_Release: "Waiting period for asset release",
        Waiting_Period_For_Asset_Release_After_Withdrawal:
          "Waiting period for asset release after withdrawal",
        Plan_Join_Date: "Plan join date",
        Withdrawal_Date: "Withdrawal date",
        Renewal_End_Date: "Renewal end date",
        Withdraw_From_Plan: "Withdraw from plan",
        Confirm_Withdrawal_Message:
          "By withdrawing from the plan, you will not receive the current period’s rewards and a withdrawal fee may be deducted. We recommend staying in the plan until the end of the current period to earn rewards. Are you sure you want to withdraw from the plan?"
      },
      planSchedule: {
        Registration_Date: "Registration Date",
        Start_Of_Staking_Plan: "Start of Your Staking Plan",
        Start_Of_Staking: "Start of Staking Plan",
        Daily_Profit_Distribution_Date: "Daily Profit Distribution Date",
        Plan_End_Date: "Plan End Date",
        Profit_Release_Date: "Profit Release Date",
        Asset_Release_Date: "Asset Release Date",
        Enable_Auto_Renewal_Description:
          "By enabling this option, you can renew your plan automatically",
        Enable_Auto_Renewal: "Enable Auto Renewal",
        Disable_Auto_Renewal: "Disable Auto Renewal",
        Plan_Renewal: "Plan Renewal",
        Auto_Renewal_Description:
          "With auto-renewal enabled, your assets will be transferred to the next staking period at the end of the current one. Note that the staking rewards for each period will be deposited into your wallet and will not be carried over to the next period.",
        Auto_Renewal_Disabled_Description:
          "By disabling auto-renewal, your assets will not be automatically renewed after the staking period ends, and you will need to renew manually."
      },
      rewardTable: {
        Date: "Date",
        Reward_Percentage: "Reward Percentage",
        Daily_Received_Amount: "Daily Received Amount"
      },
      ContributionHistory: {
        courseStart: "Start plan",
        status: "status"
      },
      inviteFriends: {}
    }
  },
  calculator: {
    title: "Staking Reward Calculator",
    description:
      "You can calculate your approximate reward by entering your desired amount.",
    step1: "Step 1",
    step2: "Approximate reward over the time periods of this plan",
    aproximateReward: "Calculated Approximate Reward",
    day: "Day",
    attentStakingBtn: "Join Plan",
    participaterAmount: "Participation Amount",
    assetAmount: "Asset Amount"
  },
  features: {
    feature1: {
      title: "Passive Income",
      description:
        "With staking, you can earn income from your digital assets without the need for trading or mining, and receive periodic rewards."
    },
    feature2: {
      title: "Network Security and Stability",
      description:
        "By locking your digital currencies, you help secure the blockchain and participate in transaction validation."
    },
    feature3: {
      title: "Excoino Multi-Staking",
      description:
        "You can rejoin the same staking plan as many times as you want after participating in a plan."
    },
    feature4: {
      title: "Lower Energy Consumption Compared to Mining",
      description:
        "Unlike mining, which requires powerful hardware and a lot of electricity, staking requires minimal resources."
    },
    feature5: {
      title: "Low Risk",
      description:
        "With staking, you don’t need to predict prices in real time, and market fluctuations have less impact on your profits."
    }
  },
  stakingDetailPage: {
    canCancel: "Possibility to cancel the plan",
    Registration_Deadline: "Registration Deadline",
    Renewal_End_Date: "Renewal End Date",
    Agree_Staking_Contract_HTML:
      'I have read and agree to the <span class="primary--text">staking contract</span>.',
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly",
    minParticipation: "Minimum participation amount",
    assets: "Assets",
    your_plans_step: "Your Plan Steps",
    maxTransfer: "Exceeds Allowed Limit",
    minTransfer: "Below Allowed Limit",
    minAPR: "Min APR",
    maxAPR: "Max APR",
    activeAPR: "Active APR",
    maxPlanCapacity: "Max Plan Capacity",
    entryFee: "Entry Fee",
    cancelFee: "Cancel Fee",
    planDetails: "Plan Details",
    assetReleaseDuration: "Asset Release Duration",
    oneDayAfterPlanCompletion: "{day} day after plan completion",
    oneDayAfterWithdrawal: "{day} day after withdrawal",
    subscriptionPlanTimeline: "Plan Schedule",
    PossibilityCanceling: "Possibility of canceling"
  },
  statusPage: {
    Plan_Activated: "Your plan has been activated.",
    View_My_Plans: "View My Plans",
    Plans_List: "Plans List"
  },
  FAQ: {
    faq1: {
      title: "What is staking and how does it work?",
      desc:
        "Staking means depositing your crypto assets into a Proof of Stake network or a liquidity platform. You earn daily or periodic rewards while supporting network security.<br><br>" +
        "Excoino makes this process simple so you can earn passive income with just a few clicks, no technical knowledge required."
    },
    faq2: {
      title: "What is the difference between fixed and flexible reward plans?",
      desc:
        "Fixed APR plan: The annual reward rate is predetermined and distributed uniformly on a daily basis.<br><br>" +
        "Flexible APR plan: A minimum reward rate is guaranteed, but the actual APR may vary depending on market conditions."
    },
    faq3: {
      title: "Can I withdraw my funds before the end of the plan?",
      desc:
        "Yes. In flexible plans, instant withdrawals are allowed and assets can be traded or withdrawn in your spot wallet. For locked plans, early withdrawal may result in reward deduction."
    },
    faq4: {
      title: "How are the rewards calculated and received?",
      desc:
        "Rewards are calculated daily and typically transferred to your wallet after plan activation.<br><br>" +
        "    • For fixed plans, the annual return is divided by 365 and applied daily.<br><br>" +
        "    • For flexible plans, APR may vary daily based on market performance."
    },
    faq5: {
      title: "What is the minimum and maximum staking amount?",
      desc:
        "Minimum and maximum deposit limits apply to ensure efficiency and economic value. Excoino sets these limits per plan."
    },
    faq6: {
      title: "Which cryptocurrencies are supported for staking?",
      desc:
        "Excoino supports a range of popular cryptocurrencies for staking, including:<br><br>" +
        "ETH, ADA, DOT, PAXG, XRP, AVAX, and more.<br><br>" +
        'You can find the full list in the "Participation Pools" section.'
    },
    faq7: {
      title: "How trustworthy is staking with Excoino? What should I know?",
      desc:
        "Staking at Excoino prioritizes asset security and transparency. You can trust plans that:<br><br>" +
        "    • Clearly present reward rates, duration, and withdrawal conditions<br><br>" +
        "    • Keep your funds in secure, controlled environments<br><br>" +
        "    • Warn you of potential risks like market volatility or asset lock-up, so you can make well-informed decisions<br><br>" +
        "We recommend reviewing each plan’s terms or contacting support if needed. We're here to help you make the best choice."
    }
  }
};
